<template>
    <div v-if="lang" class="form-check">
        <input
            v-model="current_value"
            class="form-check-input"
            type="checkbox"
            :id="id"
        >

        <label class="form-check-label" :for="id">
            <tooltip :text="currentLang.agreements.marketing_agency.tooltip">
                {{ currentLang.agreements.marketing_agency.label }}
            </tooltip>
        </label>
    </div>
</template>

<script>
import Tooltip from '../Tooltip'

export default {
    components: {
        'tooltip': Tooltip,
    },

    props: {
        id: {
            type: String,
            default: 'marketing-agency-checkbox',
        },

        lang: {
            type: Object,
            required: true,
        },

        value: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            current_value: this.value,
        }
    },

    computed: {
        currentLang() {
            return this.lang
        },
    },

    watch: {
        current_value() {
            this.$emit('input', this.current_value)
        },
    },
}
</script>
